import { ComponentProps } from 'react'
import { ScaleControl } from 'react-map-gl'

interface MapScaleProps extends ComponentProps<typeof ScaleControl> {}

export function MapScale({ position, ...rest }: MapScaleProps) {
  return (
    <ScaleControl
      {...rest}
      position={position || 'bottom-left'}
      style={{
        border: '1px solid #6EBC0A',
        padding: '0.5rem',
        backgroundColor: '#ffffff',
        borderRadius: '1rem',
        fontSize: '0.875rem', // 14px
        minWidth: '5rem',
        textAlign: 'center',
      }}
    />
  )
}
